import script from "./Screening.vue?vue&type=script&setup=true&lang=js"
export * from "./Screening.vue?vue&type=script&setup=true&lang=js"

import "./Screening.vue?vue&type=style&index=0&id=071d8769&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071d8769"]])

export default __exports__